
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 16.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#35bdd1","stroke":"#35bdd1"}},[_c('path',{attrs:{"data-name":"Path 584","d":"M17.998 15.999h-16a1.5 1.5 0 0 1-1.5-1.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2a1.5 1.5 0 0 1-1.5 1.5z"}}),_c('path',{attrs:{"data-name":"Path 585","d":"M15.354 5.646l-5-5a.5.5 0 0 0-.707 0l-5 5a.5.5 0 0 0 .707.707L9.5 2.207v10.292a.5.5 0 0 0 1 0V2.206l4.146 4.146a.5.5 0 0 0 .708-.707z"}})])])
          )
        }
      }
    